import { defineComponent as _defineComponent } from 'vue'
import UserDepartmentTable from "./content/UserDepartmentTable.vue";

type Props = {
  userId: number;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'UserDepartment',
  props: {
    userId: null
  },
  setup(__props: any) {



return { __sfc: true,UserDepartmentTable }
}

})